import {  IsNotEmpty, IsAlphanumeric, IsOptional, IsNumber } from 'class-validator';
import { ApiProperty } from '@nestjs/swagger';

export class QualificationsRequest {
    @ApiProperty()
    @IsNotEmpty()
    @IsAlphanumeric()
    qualificationId: number;

    @ApiProperty()
    @IsOptional()
    updatedUser: string;

    @ApiProperty()
    @IsOptional()
    @IsNumber()
    versionFlag: number;

    @ApiProperty()
    isActive: boolean;
}